// Static UI strings the wrapper interpolates into the tier price line. Only the
// price-period suffix lives here — it combines with the ISO currency code
// (`SGD / trip`), which is wrapper-side data. The renderer owns its own
// presentational strings (the boolean "included" accessible name and the
// scroll-affordance labels) in the submodule, mirroring M3 PlanTierSelector.
// ZH-HK covers MoneyHero; SingSaver (SG) has no ZH locale so the default (`_`)
// applies. `perTrip` / `perYear` mirror the M3 Plan Tier Selector copy for
// cross-module consistency on the same page.
const translations = {
  perTrip: {
    _: 'trip',
    'zh-hk': '次旅行',
  },
  perYear: {
    _: 'year',
    'zh-hk': '年',
  },
};

export default translations;
